import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "checkbox", 
    "progressBar", 
    "progressText", 
    "progressPercent",
    "checkedCount",
    "uncheckedCount",
    "categoryCount",
    "categoryBadge"
  ];

  connect() {
    this.totalCheckboxes = this.checkboxTargets.length;
    this.updateProgress();
  }

  updateProgress() {
    const checkedBoxes = this.checkboxTargets.filter(cb => cb.checked);
    const checkedCount = checkedBoxes.length;
    const uncheckedCount = this.totalCheckboxes - checkedCount;
    const percentage = this.totalCheckboxes > 0 
      ? Math.round((checkedCount / this.totalCheckboxes) * 100) 
      : 0;

    // Update progress bar
    if (this.hasProgressBarTarget) {
      this.progressBarTarget.style.width = `${percentage}%`;
    }

    // Update progress text
    if (this.hasProgressTextTarget) {
      this.progressTextTarget.textContent = `${checkedCount} of ${this.totalCheckboxes} items checked`;
    }

    // Update percentage
    if (this.hasProgressPercentTarget) {
      this.progressPercentTarget.textContent = `${percentage}%`;
    }

    // Update counts
    if (this.hasCheckedCountTarget) {
      this.checkedCountTarget.textContent = checkedCount;
    }
    if (this.hasUncheckedCountTarget) {
      this.uncheckedCountTarget.textContent = uncheckedCount;
    }

    // Update category counts
    this.updateCategoryProgress();
  }

  updateCategoryProgress() {
    // Group checkboxes by category
    const categories = {};
    
    this.checkboxTargets.forEach(checkbox => {
      const category = checkbox.closest('[data-category]')?.dataset.category;
      if (category) {
        if (!categories[category]) {
          categories[category] = { total: 0, checked: 0 };
        }
        categories[category].total++;
        if (checkbox.checked) {
          categories[category].checked++;
        }
      }
    });

    // Update category count displays
    this.categoryCountTargets.forEach(el => {
      const category = el.dataset.category;
      if (category && categories[category]) {
        el.textContent = `${categories[category].checked}/${categories[category].total}`;
      }
    });

    // Update category badges in sidebar
    this.categoryBadgeTargets.forEach(el => {
      const category = el.dataset.category;
      if (category && categories[category]) {
        el.textContent = `${categories[category].checked}/${categories[category].total}`;
      }
    });
  }
}
